export const PSYCHIATRY_INTRO_SERVICE_ID = parseInt(process.env.NEXT_PUBLIC_PSYCHIATRY_INTRO_SERVICE_ID, 10)
